import {
  PaymentTransaction,
} from '@dapi/sdk';
import {
  baseAmount,
  zeroAmountInSek,
} from './amount';
import {
  currency,
  inrCurrency,
  myRinggitCurrency,
  sekCurrency,
} from './currency';
import {
  milesPaymentMethod,
  paymentCard,
  paymentCardCA,
  paymentMethod,
  payPalPayment,
  voucherPayment,
  voucherPayment2,
  voucherPayment3,
} from './payment';

export const paymentDetails: PaymentTransaction = {
  amount: {
    ...baseAmount,
    value: 2345
  },
  paymentMethod: paymentMethod
};

export const customPaymentTransaction: PaymentTransaction = {
  paymentMethod: {
    id: 'FFA',
    paymentType: 'CustomPayment'
  },
  amount: zeroAmountInSek
};

export const cardPaymentTransaction: PaymentTransaction = {
  paymentMethod: paymentCard,
  amount: {
    ...zeroAmountInSek,
    value: 5686
  }
};

export const cardPaymentTransactionCA: PaymentTransaction[] = [{
  paymentMethod: paymentCardCA,
  amount: {
    ...zeroAmountInSek,
    value: 6500
  }
}];

export const arnEwrPaymentTransactions: PaymentTransaction[] = [
  {
    paymentMethod: paymentCard,
    amount: {
      value: 11_213,
      currencyCode: 'SEK',
      currency: sekCurrency
    },
    authorization: {
      approvalCode: 'APS1OK'
    }
  }
];

export const creditCardpaymentTransactions: PaymentTransaction[] = [
  {
    paymentMethod: paymentCard,
    amount: {
      value: 39_342,
      currencyCode: 'EUR',
      currency
    },
    authorization: {
      approvalCode: 'APS1OK'
    }
  }
];

export const paypalPaymentTransactions: PaymentTransaction[] = [
  {
    paymentMethod: payPalPayment,
    amount: {
      value: 189_700,
      currencyCode: 'MYR',
      currency: myRinggitCurrency
    }
  }
];

export const voucherPaymentTransactions: PaymentTransaction[] = [
  {
    paymentMethod: voucherPayment,
    amount: {
      value: 733_700,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '2356810596'
    }
  }
];

export const multipleVoucherTransaction: PaymentTransaction[] = [
  {
    paymentMethod: voucherPayment,
    amount: {
      value: 1_000_000,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '9228212821'
    }
  },
  {
    paymentMethod: voucherPayment2,
    amount: {
      value: 1_000_000,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '2356810596'
    }
  },
  {
    paymentMethod: voucherPayment3,
    amount: {
      value: 838_400,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '2356810598'
    }
  }
];

export const multipleVoucherTransactionAfterCancellation: PaymentTransaction[] = [
  {
    paymentMethod: voucherPayment,
    amount: {
      value: 1_000_000,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '9228212821'
    }
  },
  {
    paymentMethod: voucherPayment2,
    amount: {
      value: 1_000_000,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '2356810596'
    }
  },
  {
    paymentMethod: voucherPayment3,
    amount: {
      value: 798_500,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '2356810598'
    }
  }
];

export const multipleVoucherWithCCTransaction: PaymentTransaction[] = [
  {
    paymentMethod: voucherPayment,
    amount: {
      value: 519_600,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '9228212821'
    }
  },
  {
    paymentMethod: voucherPayment2,
    amount: {
      value: 641_800,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: '2356810596'
    }
  },
  {
    paymentMethod: paymentCard,
    amount: {
      value: 1_537_000,
      currencyCode: 'INR',
      currency: inrCurrency
    },
    authorization: {
      approvalCode: 'APS1OK'
    }
  }
];

export const milesPaymentTransactions: PaymentTransaction[] = [
  {
    paymentMethod: milesPaymentMethod,
    amount: {
      value: 31_600,
      currency: {
        name: 'Miles',
        decimalPlaces: 0
      },
      currencyCode: 'MIL'
    },
    authorization: {
      approvalCode: '222012009749273'
    }
  },
  {
    paymentMethod: paymentCard,
    amount: {
      ...zeroAmountInSek,
      value: 5686
    },
    authorization: {
      approvalCode: '927742'
    }
  }
];

export const milesPaymentTransactionsWithoutCancellation: PaymentTransaction[] = [
  {
    paymentMethod: milesPaymentMethod,
    amount: {
      value: 19_000,
      currency: {
        name: 'Miles',
        decimalPlaces: 0
      },
      currencyCode: 'MIL'
    },
    authorization: {
      approvalCode: '222012009749273'
    }
  },
  {
    paymentMethod: paymentCard,
    amount: {
      ...zeroAmountInSek,
      value: 5825
    },
    authorization: {
      approvalCode: '927742'
    }
  }
];

export const milesPaymentTransactionsZeroMiles: PaymentTransaction[] = [
  {
    paymentMethod: milesPaymentMethod,
    amount: {
      value: 0,
      currency: {
        name: 'Miles',
        decimalPlaces: 0
      },
      currencyCode: 'MIL'
    },
    authorization: {
      approvalCode: '222012009749273'
    }
  },
  {
    paymentMethod: paymentCard,
    amount: {
      ...zeroAmountInSek,
      value: 5825
    },
    authorization: {
      approvalCode: '927742'
    }
  }
];
